import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { Draggable } from 'react-beautiful-dnd'
import moment from 'moment'
const Container = styled.div`
  border : 1px solid lightgray;
  padding : 8px;
  margin-bottom : 8px;
  border-radius : 4px;
  color: ${props =>
    props.isDragging
      ? 'white '
      : 'black'};
  background-color: ${props =>
    props.isDragDisabled
      ? 'lightgrey'
      : props.isDragging
        ? 'rgb(50, 51, 209)'
        : 'white'};
        
  &:hover {
    background-color : #fafafa;
  }
  .deal__name{
    color: ${props => props.isDragging
    ? 'white'
    : '#2c40ce'};
  }
`

export default function DealsCard({ deal, index, setShowDealModal }) {

  const [formattedDate, setFormattedDate] = useState('')
  let date = moment(deal.closeDate.value).format('MM/DD/YYYY')
  useEffect(() => {
    if (date === 'Invalid date') {
      setFormattedDate('')
    } else {
      setFormattedDate(date)
    }
  }, [date])
  return (
    <Draggable
      key={deal.id}
      draggableId={deal.id}
      index={index}
    >
      {
        (provided, snapshot) => (
          <Container
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            isDragging={snapshot.isDragging}
            ref={provided.innerRef}
            onClick={() => setShowDealModal(deal)}

          >
            <div className="deal__name">{deal.name.value}</div>
            <div><span style={{ fontWeight: '500' }}>Amount: </span>{deal.amount.value} </div>
            <div><span style={{ fontWeight: '500' }}>Close date: </span>{formattedDate} </div>
            <div><span style={{ fontWeight: '500' }}>Desciption: </span>{deal.text.value}</div>
          </Container>
        )
      }

    </Draggable>
  )
}
